import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    color?: string;
    width?: number;
    height?: number;
};

export const ChevronRightIcon = (props: Props) => {
    const { color = 'currentColor', width = 16, height = 26, ...rest } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 16 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M3.09833 0L0 2.78778L9.56944 12.6028L0 23.1978L3.09833 26L15.1883 12.6172L3.09833 0Z" fill={color} />
        </svg>
    );
};
